import Access from "./Access";
import AccessV1 from "./AccessV1";
import Approval from "./Approval";
import ApprovalV1 from "./ApprovalV1";
import Initialization from "./Initialization";
import InitializationV1 from "./InitializationV1";
import Intent from "./Intent";
import IntentV1 from "./IntentV1";
import Login from "./Login";
import LoginV1 from "./LoginV1";
import Notification from "./Notification";
import NotificationV1 from "./NotificationV1";
import Plan from "./Plan";
import PlanV1 from "./PlanV1";
import Push from "./Push";
import PushV1 from "./PushV1";
import Task from "./Task";
import TaskV1 from "./TaskV1";
import Trigger from "./Trigger";
import TriggerV1 from "./TriggerV1";

const templatesV0 = {
  ACCESS: Access,
  APPROVAL: Approval,
  INITIALIZATION: Initialization,
  LOGIN: Login,
  PLAN: Plan,
  PUSH: Push,
  TASK: Task,
  TRIGGER: Trigger,
  NOTIFICATION: Notification,
  INTENT: Intent,
};
const templatesV1 = {
  ACCESS: AccessV1,
  APPROVAL: ApprovalV1,
  INITIALIZATION: InitializationV1,
  LOGIN: LoginV1,
  PLAN: PlanV1,
  PUSH: PushV1,
  TASK: TaskV1,
  TRIGGER: TriggerV1,
  NOTIFICATION: NotificationV1,
  INTENT: IntentV1,
};

export { templatesV0, templatesV1 };
